/**
 * useRecommendedProducts
 *
 * Fetches product recommendations for PDP cross-sell.
 * The `enabled` flag allows deferring the request until the section
 * scrolls into view (via IntersectionObserver / useScrollReveal).
 */

'use client';

import { useQuery } from '@tanstack/react-query';
import { GetRecommendedProductsUseCase } from '@/application/use-cases/get-recommended-products.use-case';
import { productService } from '@/infrastructure/config/services.config';

const getRecommendedProductsUseCase = new GetRecommendedProductsUseCase(productService);

export function useRecommendedProducts(productId: string, enabled = true) {
  return useQuery({
    queryKey: ['recommended-products', productId],
    queryFn: async () => {
      const result = await getRecommendedProductsUseCase.execute({ productId, limit: 8 });
      return result.products;
    },
    enabled: !!productId && enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
